import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=0cdf68b4&"
import script from "./Finish.vue?vue&type=script&lang=js&"
export * from "./Finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports